import { createClient } from '@supabase/supabase-js'

// Supabase configuration
// These can be overridden by environment variables:
// VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY

// Helper to safely get environment variables
// Supports both Vite (VITE_) and Create React App (REACT_APP_) prefixes
const getEnvVar = (
  viteKey: string,
  reactKey: string,
  defaultValue: string = '',
): string => {
  // Check if import.meta.env exists (Vite)
  if (typeof import.meta !== 'undefined' && import.meta.env) {
    const viteValue = import.meta.env[viteKey]
    if (viteValue) return viteValue
  }

  // Check process.env for React/Node environments
  if (typeof process !== 'undefined' && process.env) {
    const reactValue = (process.env as Record<string, string | undefined>)[
      reactKey
    ]
    if (reactValue) return reactValue
  }

  return defaultValue
}

// Supabase credentials - using environment variables with fallback to configured values
const supabaseUrl = getEnvVar(
  'VITE_SUPABASE_URL',
  'REACT_APP_SUPABASE_URL',
  'https://cbqoveptykptzlkahamd.supabase.co',
)
const supabaseAnonKey = getEnvVar(
  'VITE_SUPABASE_ANON_KEY',
  'REACT_APP_SUPABASE_ANON_KEY',
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNicW92ZXB0eWtwdHpsa2FoYW1kIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjQ1OTcyMjYsImV4cCI6MjA4MDE3MzIyNn0.H5ACvm51wHe8uUpXBDCD31qRLtsM0lGl8O_hwH0qUgE',
)

// Create Supabase client
export const supabase = createClient(supabaseUrl, supabaseAnonKey)

// Check if Supabase is properly configured
export const isSupabaseConfigured = (): boolean => {
  return !!(
    supabaseUrl &&
    supabaseAnonKey &&
    !supabaseUrl.includes('placeholder')
  )
}
